// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__HIY+T","footerLogo":"footer_footerLogo__7hvGc","footerCopyright":"footer_footerCopyright__Xlm5H","footerHead":"footer_footerHead__l+sHk"};